import React, {Component} from 'react';
import styles from "../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import Button from "../../../../../components/button/Button";
import Icon from "../../../../../components/icon/Icon";
import Autocomplete from "../../../../../components/autocomplete/Autocomplete";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../utils/OggettiUtili"
import Select from "../../../../../components/select/Select"
import Input from "../../../../../components/textbox/Input";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli.json";



class ViaggiSoggiorni extends Component {


    state = {
        viaggiESoggiorni: {
            viaggiOSoggiorniFuoriItalia: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "3*" : "",
            estero: [
                {
                    paeseEsteroVisitato: "",
                    motivoDelViaggio: "",
                    dataDiPartenzaDallItalia: "",
                    dataRientroOArrivoInItalia: "",
                    periodoDiPresenzaInItalia: "",
                    noteEstero: ""
                }
            ],

            viaggiOSoggiorniInItalia: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "3*" : "",
            nazionale: [
                {
                    provincia: "",
                    dataDiPartenza: "",
                    dataRientroArrivo: "",
                    noteNazionale: ""
                }
            ],
            mezzoPubblicoNazionale: "",
            infoMezzoPubblicoNazionale: "",
            corretto: []
        },
        clickSoggiornoEstero: 0,
        boxesSoggiornoEstero: [],
        clickSoggiornoNazionale: 0,
        boxesSoggiornoNazionale: [],
        viaggiFuoriItalia: OggettiUtili.ViaggiFuoriItalia,
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        motivoViaggi: OggettiUtili.MotivoViaggio,
        tempoPrezenzaItalia: OggettiUtili.PresenzaInItalia,
        viaggiInItalia: OggettiUtili.ViaggiInItalia,
        province: JSON.parse(sessionStorage.getItem("province")),
        provinciePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice")),
    }

    constructor(props) {
        super(props);
        this.aggiungiEstero = this.aggiungiEstero.bind(this);
        this.aggiungiNazionale = this.aggiungiNazionale.bind(this);
        this.onClickAggiungiSoggiornoEstero = this.onClickAggiungiSoggiornoEstero.bind(this)
        this.onClickAggiungiSoggiornoNazionale = this.onClickAggiungiSoggiornoNazionale.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.handleChangeViaggiFuoriItalia = this.handleChangeViaggiFuoriItalia.bind(this);
        this.handleChangeViaggiInItalia = this.handleChangeViaggiInItalia.bind(this);
        this.handleChangeMotivo = this.handleChangeMotivo.bind(this);
        this.handleChangePresenza = this.handleChangePresenza.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.validate = this.validate.bind(this)
        this.setValoriInModifica = this.setValoriInModifica.bind(this)
        this.uniqueObjectEstero = this.uniqueObjectEstero.bind(this)
        this.uniqueObjectNazionale = this.uniqueObjectNazionale.bind(this)
        this.eliminaRowEstero = this.eliminaRowEstero.bind(this)
        this.eliminaRowNazionale = this.eliminaRowNazionale.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.datiSpecifici) {


            if (this.props.segnalazioneCopia.datiSpecifici.viaggiESoggiorni) {
                this.setValoriInModifica()
                this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this)
            } else {
                this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this)
                this.onClickAggiungiSoggiornoEstero();
                this.onClickAggiungiSoggiornoNazionale();
            }
        } else {
            this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this)

            this.onClickAggiungiSoggiornoEstero();
            this.onClickAggiungiSoggiornoNazionale();
        }
        // this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this)
        this.controlloDati()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clickSoggiornoEstero > this.state.clickSoggiornoEstero) {
            this.onClickAggiungiSoggiornoEstero()
            this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this)
        }
        if (prevState.clickSoggiornoNazionale > this.state.clickSoggiornoNazionale) {
            this.onClickAggiungiSoggiornoNazionale();
            this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this)
        }
        if (Utils.areObjectsEquivalent(prevState.viaggiESoggiorni, this.state.viaggiESoggiorni)) {
            this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this)

        }
    }

    setValoriInModifica() {
        let viaggiSoggiorni = this.state.viaggiESoggiorni
        let propsViaggi = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.viaggiESoggiorni));
        viaggiSoggiorni.viaggiOSoggiorniFuoriItalia = propsViaggi.viaggiOSoggiorniFuoriItalia
        viaggiSoggiorni.viaggiOSoggiorniInItalia = propsViaggi.viaggiOSoggiorniInItalia
        viaggiSoggiorni.estero = propsViaggi.estero ? propsViaggi.estero : this.state.viaggiESoggiorni.estero
        viaggiSoggiorni.nazionale = propsViaggi.nazionale ? propsViaggi.nazionale : this.state.viaggiESoggiorni.nazionale
        if (propsViaggi.estero) {
            for (let i = 0; i < propsViaggi.estero.length; i++) {
                viaggiSoggiorni.estero[i].paeseEsteroVisitato = propsViaggi.estero[i].paeseEsteroVisitato ? this.state.nazioniPerCodice[propsViaggi.estero[i].paeseEsteroVisitato.codice] : ""
            }
        }
        if (propsViaggi.nazionale) {
            for (let i = 0; i < propsViaggi.nazionale.length; i++) {
                viaggiSoggiorni.nazionale[i].provincia = propsViaggi.nazionale[i].provincia ?
                    this.state.provinciePerCodice[propsViaggi.nazionale[i].provincia] : ""
                viaggiSoggiorni.nazionale[i].dataDiPartenza = propsViaggi.nazionale[i].dataDiPartenza ? propsViaggi.nazionale[i].dataDiPartenza : ""
                viaggiSoggiorni.nazionale[i].dataRientroArrivo = propsViaggi.nazionale[i].dataRientroArrivo ? propsViaggi.nazionale[i].dataRientroArrivo : ""
            }
        }
        viaggiSoggiorni.mezzoPubblicoNazionale = propsViaggi.mezzoPubblicoNazionale ? propsViaggi.mezzoPubblicoNazionale : ""
        viaggiSoggiorni.infoMezzoPubblicoNazionale = propsViaggi.infoMezzoPubblicoNazionale ? propsViaggi.infoMezzoPubblicoNazionale : ""
        this.setState({viaggiSoggiorni: viaggiSoggiorni})
        if (viaggiSoggiorni.estero) {
            for (let i = 0; i < viaggiSoggiorni.estero.length; i++) {
                this.onClickAggiungiSoggiornoEstero();
                this.state.clickSoggiornoEstero++
            }
        } else {
            this.onClickAggiungiSoggiornoEstero();

        }
        if (viaggiSoggiorni.nazionale) {
            for (let i = 0; i < viaggiSoggiorni.nazionale.length; i++) {
                this.onClickAggiungiSoggiornoNazionale();
                this.state.clickSoggiornoNazionale++
            }
        } else {
            this.onClickAggiungiSoggiornoNazionale();
        }
    }

    handleChangeViaggiFuoriItalia(event) {
        let viaggiNew = this.state.viaggiESoggiorni
        viaggiNew.viaggiOSoggiorniFuoriItalia = event.target.value;
        this.setState({
            // boxesSoggiornoEstero: [],
            viaggiESoggiorni: viaggiNew,
            clickSoggiornoEstero: this.state.clickSoggiornoEstero--,
        });
        this.controlloDati()
        this.onClickAggiungiSoggiornoEstero();
    }

    handleChangeViaggiInItalia(event) {
        let viaggiNew = this.state.viaggiESoggiorni
        viaggiNew.viaggiOSoggiorniInItalia = event.target.value;
        this.setState({
            //  boxesSoggiornoNazionale: [],
            viaggiESoggiorni: viaggiNew,
            clickSoggiornoNazionale: this.state.clickSoggiornoNazionale--,
        });
        this.controlloDati();
        this.onClickAggiungiSoggiornoNazionale();
    }

    handleChangeMotivo(event) {
        let viaggiNew = this.state.viaggiESoggiorni
        let click = this.state.clickSoggiornoEstero - 1
        let indice = parseInt(event.target.id.replace("motivoViaggio", ""))
        viaggiNew.estero[indice].motivoDelViaggio = event.target.value
        this.setState({viaggiESoggiorni: viaggiNew, clickSoggiornoEstero: click});
        this.controlloDati();
    }


    handleChangePresenza(event) {
        let viaggiNew = this.state.viaggiESoggiorni
        console.log("id " + event.target.id)
        let click = this.state.clickSoggiornoEstero - 1
        let indice = parseInt(event.target.id.replace("periodoDiPresenzaInItalia", ""))
        viaggiNew.estero[indice].periodoDiPresenzaInItalia = event.target.value
        this.setState({viaggiESoggiorni: viaggiNew, clickSoggiornoEstero: click});
        this.controlloDati()
    }

    uniqueObjectEstero(elViaggiEstero) {

        const tmpEstero = new Map()
        let viaggi = JSON.parse(JSON.stringify(this.state.viaggiESoggiorni))
        let vuoto = Utils.isEmpty(elViaggiEstero[0])

        if (!vuoto) {
            const rsEstero = elViaggiEstero.reduce((acc, e) => {

                if (tmpEstero.has(e.paeseEsteroVisitato.codice) && tmpEstero.has(e.motivoDelViaggio) && tmpEstero.has(e.dataDiPartenzaDallItalia) && tmpEstero.has(e.dataRientroOArrivoInItalia) && tmpEstero.has(e.periodoDiPresenzaInItalia)) {
                    if (!tmpEstero.get(e.paeseEsteroVisitato.codice).includes(e.jobid) && !tmpEstero.get(e.motivoDelViaggio).includes(e.jobid) && !tmpEstero.get(e.dataDiPartenzaDallItalia).includes(e.jobid) && !tmpEstero.get(e.dataRientroOArrivoInItalia).includes(e.jobid) && !tmpEstero.get(e.periodoDiPresenzaInItalia).includes(e.jobid)) {
                        acc.push(e)
                        tmpEstero.set(e.paeseEsteroVisitato.codice, [...tmpEstero.get(e.paeseEsteroVisitato.codice), e.jobid])
                        tmpEstero.set(e.motivoDelViaggio, [...tmpEstero.get(e.motivoDelViaggio), e.jobid])
                        tmpEstero.set(e.dataDiPartenzaDallItalia, [...tmpEstero.get(e.dataDiPartenzaDallItalia), e.jobid])
                        tmpEstero.set(e.dataRientroOArrivoInItalia, [...tmpEstero.get(e.dataRientroOArrivoInItalia), e.jobid])
                        tmpEstero.set(e.periodoDiPresenzaInItalia, [...tmpEstero.get(e.periodoDiPresenzaInItalia), e.jobid])
                    }
                } else {
                    acc.push(e)
                    tmpEstero.set(e.paeseEsteroVisitato.codice, [e.jobid])
                    tmpEstero.set(e.motivoDelViaggio, [e.jobid])
                    tmpEstero.set(e.dataDiPartenzaDallItalia, [e.jobid])
                    tmpEstero.set(e.dataRientroOArrivoInItalia, [e.jobid])
                    tmpEstero.set(e.periodoDiPresenzaInItalia, [e.jobid])
                }
                return acc
            }, [])

            viaggi.estero = rsEstero
        }

        return viaggi.estero
    }

    uniqueObjectNazionale(elViaggi) {
        const tmpNazionale = new Map()
        let viaggi = JSON.parse(JSON.stringify(this.state.viaggiESoggiorni))
        let vuoto = Utils.isEmpty(elViaggi[0])

        if (!vuoto) {
            const rsNazionale = elViaggi.reduce((acc, e) => {
                if (tmpNazionale.has(e.provincia.codice) && tmpNazionale.has(e.dataDiPartenza) && tmpNazionale.has(e.dataRientroArrivo)) {
                    if (!tmpNazionale.get(e.provincia.codice).includes(e.jobid) && !tmpNazionale.get(e.dataDiPartenza).includes(e.jobid) && !tmpNazionale.get(e.dataRientroArrivo).includes(e.jobid)) {
                        acc.push(e)
                        tmpNazionale.set(e.provincia.codice, [...tmpNazionale.get(e.provincia.codice), e.jobid])
                        tmpNazionale.set(e.dataDiPartenza, [...tmpNazionale.get(e.dataDiPartenza), e.jobid])
                        tmpNazionale.set(e.dataRientroArrivo, [...tmpNazionale.get(e.dataRientroArrivo), e.jobid])
                    }
                } else {
                    acc.push(e)
                    tmpNazionale.set(e.provincia.codice, [e.jobid])
                    tmpNazionale.set(e.dataDiPartenza, [e.jobid])
                    tmpNazionale.set(e.dataRientroArrivo, [e.jobid])
                }
                return acc
            }, [])

            viaggi.nazionale = rsNazionale
        }
        return viaggi.nazionale
    }

    validate() {

        for (let i = 0; i < this.state.viaggiESoggiorni.estero.length; i++) {
            //Estero
            let validateDataDiPartenzaDallItalia = this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia ? Utils.checkDateInterval(this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia, "31/12/1899") : false;
            let checkTodayDataDiPartenzaDallItalia = this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia ? Utils.checkDateLowerToday(this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia) : false;
            let validateDataRientroOArrivoInItalia = this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia ? Utils.checkDateInterval(this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia, "31/12/1899") : false;
            let checkTodayDataRientroOArrivoInItalia = this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia ? Utils.checkDateLowerToday(this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia) : false;
            let confrontoDataRientroOArrivoInItaliaEDataDiPartenzaDallItalia =
                Utils.checkDateIntervalMinore(this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia, this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia);
            if (validateDataDiPartenzaDallItalia) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0C"]), 1
                )
            } else if (checkTodayDataDiPartenzaDallItalia) {
                return (
                    this.props.aggiungiToaster(["Messages.ERR_01_01_0F_0D"]), 1
                )

            }
            if (validateDataRientroOArrivoInItalia) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0E"]), 1
                )
            } else if (checkTodayDataRientroOArrivoInItalia) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0F"]), 1
                )
            } else if (confrontoDataRientroOArrivoInItaliaEDataDiPartenzaDallItalia) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0G"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3") && (this.state.viaggiESoggiorni.estero[i] && this.state.viaggiESoggiorni.estero[i].paeseEsteroVisitato)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0OVIAGGI"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3") && (this.state.viaggiESoggiorni.estero[i] && this.state.viaggiESoggiorni.estero[i].motivoDelViaggio)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0PVIAGGI"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3") && (this.state.viaggiESoggiorni.estero[i] && this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0QVIAGGI"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3") && (this.state.viaggiESoggiorni.estero[i] && this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0RVIAGGI"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3") && this.state.viaggiESoggiorni.estero[i].periodoDiPresenzaInItalia) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0SVIAGGI"]), 1
                )
            }
            else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3") && this.state.viaggiESoggiorni.estero[i].noteEstero) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0XVIAGGI"]), 1
                )
            }
        }
        for (let i = 0; i < this.state.viaggiESoggiorni.nazionale.length; i++) {
            //Nazionale
            let validateDataDiPartenza = this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza ? Utils.checkDateInterval(this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza, "31/12/1899") : false;
            let checkTodayDataDiPartenza = this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza ? Utils.checkDateLowerToday(this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza) : false;
            let validateDataRientroOArrivo = this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza ? Utils.checkDateInterval(this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo, "31/12/1899") : false;
            let checkTodayDataRientroOArrivo = this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza ? Utils.checkDateLowerToday(this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo) : false;
            let confrontoDataRientroOArrivoDataDiPartenza = (this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo && this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza)
                ? Utils.checkDateIntervalMinore(this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo, this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza) : false;


            if (validateDataDiPartenza) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0H"]), 1
                )
            } else if (checkTodayDataDiPartenza) {
                return (
                    this.props.aggiungiToaster(["Messages.ERR_01_01_0F_0I"]), 1
                )

            }

            if (validateDataRientroOArrivo) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0L"]), 1
                )
            } else if (checkTodayDataRientroOArrivo) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0M"]), 1
                )
            } else if (confrontoDataRientroOArrivoDataDiPartenza) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0N"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "3") && (this.state.viaggiESoggiorni.nazionale[i] && this.state.viaggiESoggiorni.nazionale[i].provincia && this.state.viaggiESoggiorni.nazionale[i].provincia.codice)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0TVIAGGI"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "3") && (this.state.viaggiESoggiorni.nazionale[i] && this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0UVIAGGI"]), 1
                )
            } else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "3") && (this.state.viaggiESoggiorni.nazionale[i] && this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0VVIAGGI"]), 1
                )
            }
            else if ((this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "2" || this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "3") && (this.state.viaggiESoggiorni.nazionale[i] && this.state.viaggiESoggiorni.nazionale[i].noteNazionale)) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0WVIAGGI"]), 1
                )
            }
        }

        let listaEstero = JSON.parse(JSON.stringify(this.state.viaggiESoggiorni.estero))
        let listaNazionale = JSON.parse(JSON.stringify(this.state.viaggiESoggiorni.nazionale))

        let arraylistaEsteroPulito = Utils.removeEmptyValueFromObject(listaEstero)
        let arraylistaNazionalePulito = Utils.removeEmptyValueFromObject(listaNazionale)
        let arrayNuovolistaEstero = Utils.eliminaNullArray(arraylistaEsteroPulito)
        let arrayNuovolistaNazionale = Utils.eliminaNullArray(arraylistaNazionalePulito)


        let viaggiUnique = JSON.parse(JSON.stringify(this.state.viaggiESoggiorni))
        viaggiUnique.estero = this.uniqueObjectEstero(arraylistaEsteroPulito);
        viaggiUnique.nazionale = this.uniqueObjectNazionale(arraylistaNazionalePulito);

        let ObjectForBackEnd = {}
        let viaggi = Object.assign({}, viaggiUnique);
        let viaggiESoggiorni = Utils.removeFieldFromObject(viaggi, "corretto");

        ObjectForBackEnd["viaggiOSoggiorniFuoriItalia"] = viaggiESoggiorni.viaggiOSoggiorniFuoriItalia
        ObjectForBackEnd["estero"] = Utils.removeEmptyValueFromObject(viaggiESoggiorni.estero)
        if (ObjectForBackEnd.estero) {
            for (let i = 0; i < viaggiESoggiorni.estero.length; i++) {
                if (viaggiESoggiorni.estero[i] && viaggiESoggiorni.estero[i].paeseEsteroVisitato) {
                    let nazione = viaggiESoggiorni.estero[i].paeseEsteroVisitato ?
                        viaggiESoggiorni.estero[i].paeseEsteroVisitato : ""
                    ObjectForBackEnd.estero[i]["paeseEsteroVisitato"] = nazione
                }
            }
        }
        ObjectForBackEnd["viaggiOSoggiorniInItalia"] = viaggiESoggiorni.viaggiOSoggiorniInItalia
        ObjectForBackEnd["nazionale"] = Utils.removeEmptyValueFromObject(viaggiESoggiorni.nazionale)
        if (ObjectForBackEnd.nazionale) {
            for (let i = 0; i < viaggiESoggiorni.nazionale.length; i++) {
                if (viaggiESoggiorni.nazionale[i] && viaggiESoggiorni.nazionale[i].provincia) {
                    let nazione = viaggiESoggiorni.nazionale[i].provincia.codice ?
                        viaggiESoggiorni.nazionale[i].provincia.codice : ""
                    ObjectForBackEnd.nazionale[i]["provincia"] = nazione
                }
            }
        }
        ObjectForBackEnd["mezzoPubblicoNazionale"] = Utils.removeEmptyValueFromObject(viaggiESoggiorni.mezzoPubblicoNazionale)
        ObjectForBackEnd["infoMezzoPubblicoNazionale"] = Utils.removeEmptyValueFromObject(viaggiESoggiorni.infoMezzoPubblicoNazionale)
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);


        this.props.setViaggiESoggiorni(this.state.viaggiESoggiorni, this, res)
    }

    controlloDati() {

        let viaggi = this.state.viaggiESoggiorni
        viaggi.corretto = []
        let controlloDati = {dataDiPartenzaDallItalia: false, dataRientroOArrivoInItalia: false, paeseEsteroVisitato: false, motivoDelViaggio: false, provincia: false, dataDiPartenza: false,dataRientroArrivo:false}

        if (!viaggi.viaggiOSoggiorniFuoriItalia) viaggi.corretto[0] = "Campo \"Viaggi o soggiorni fuori dall'Italia\" mancante"
        if(!viaggi.viaggiOSoggiorniInItalia) viaggi.corretto[1] = "Campo \"Viaggi o soggiorni in Italia\" mancante"

        for (let i = 0; i < viaggi.estero.length; i++) {

            if(viaggi.estero[i].dataDiPartenzaDallItalia && Utils.isDateInValid(Utils.transformDateForBackend(viaggi.estero[i].dataDiPartenzaDallItalia), "-") && !controlloDati.dataDiPartenzaDallItalia){
                viaggi.corretto[2] = "Campo \"Data di partenza dall'Italia\" errato"
                controlloDati.dataDiPartenzaDallItalia = true
            }
            if(viaggi.estero[i].dataRientroOArrivoInItalia && Utils.isDateInValid(Utils.transformDateForBackend(viaggi.estero[i].dataRientroOArrivoInItalia), "-") && !controlloDati.dataRientroOArrivoInItalia){
                viaggi.corretto[3] = "Campo \"Data di rientro/arrivo in Italia\" errato"
                controlloDati.dataRientroOArrivoInItalia = true
            }
            if(viaggi.viaggiOSoggiorniFuoriItalia === "1" && !viaggi.estero[i].paeseEsteroVisitato && !controlloDati.paeseEsteroVisitato){
                viaggi.corretto[4] = "Campo \"Paese estero visitato\" mancante"
                controlloDati.paeseEsteroVisitato = true
            }
            if(viaggi.viaggiOSoggiorniFuoriItalia === "1" && !viaggi.estero[i].motivoDelViaggio && !controlloDati.motivoDelViaggio){
                viaggi.corretto[5] = "Campo \"Motivo del viaggio\" mancante"
                controlloDati.motivoDelViaggio = true
            }

        }

        for (let i = 0; i < viaggi.nazionale.length; i++) {

            if((viaggi.viaggiOSoggiorniInItalia === "1") && (!viaggi.nazionale[i].provincia) && !controlloDati.provincia){
                viaggi.corretto[6] = "Campo \"Provincia\" mancante"
                controlloDati.provincia = true
            }
            if(viaggi.nazionale[i].dataDiPartenza && Utils.isDateInValid(Utils.transformDateForBackend(viaggi.nazionale[i].dataDiPartenza), "-") && !controlloDati.dataDiPartenza){
                viaggi.corretto[7] = "Campo \"Data di partenza\" mancante"
                controlloDati.dataDiPartenza = true
            }
            if(viaggi.nazionale[i].dataRientroArrivo && Utils.isDateInValid(Utils.transformDateForBackend(viaggi.nazionale[i].dataRientroArrivo), "-") && !controlloDati.dataRientroArrivo){
                viaggi.corretto[8] = "Campo \"Data di rientro/arrivo\" mancante"
                controlloDati.dataRientroArrivo = true
            }
        }


        this.setState({viaggiESoggiorni: viaggi})
    }

    riceviValore(field, event) {
        let viaggi = this.state.viaggiESoggiorni;
        let click1 = this.state.clickSoggiornoEstero - 1
        let click2 = this.state.clickSoggiornoNazionale - 1

        if (field.currentTarget) {

            if (field.currentTarget.id.includes("dataDiPartenzaDallItalia")) {
                let indice = parseInt(field.currentTarget.id.replace("dataDiPartenzaDallItalia", ""))
                viaggi.estero[indice].dataDiPartenzaDallItalia = field.target.value
            } else if (field.currentTarget.id.includes("dataRientroOArrivoInItalia")) {
                let indice = parseInt(field.currentTarget.id.replace("dataRientroOArrivoInItalia", ""))
                viaggi.estero[indice].dataRientroOArrivoInItalia = field.target.value;
            } else if (field.currentTarget.id.includes("dataDiPartenza")) {
                let indice = parseInt(field.currentTarget.id.replace("dataDiPartenza", ""))
                viaggi.nazionale[indice].dataDiPartenza = field.target.value;
            } else if (field.currentTarget.id.includes("dataRientroArrivo")) {
                let indice = parseInt(field.currentTarget.id.replace("dataRientroArrivo", ""))
                viaggi.nazionale[indice].dataRientroArrivo = field.target.value;
            }
        } else {
            if (field.includes("paeseEstero")) {
                let indice = parseInt(field.replace("paeseEstero", ""))
                viaggi.estero[indice].paeseEsteroVisitato = event.target.value
                /*let paese = event.target.value
                if (paese.codice) {
                    viaggi.estero[indice].paeseEsteroVisitato = event.target.value.codice
                }*/
                //segnalazione.malattia = event.target.value;
            } else if (field.includes("provincia")) {
                let indice = parseInt(field.replace("provincia", ""))
                viaggi.nazionale[indice].provincia = event.target.value
                /* if (provincia.codice) {
                     viaggi.nazionale[indice].provincia = event.target.value.codice
                 }*/
            } else if (field.includes("noteEstero")) {
                let indice = parseInt(field.replace("noteEstero", ""))
                viaggi.estero[indice].noteEstero = event.target.value
            } else if (field.includes("noteNazionale")) {
                let indice = parseInt(field.replace("noteNazionale", ""))
                viaggi.nazionale[indice].noteNazionale = event.target.value
            } else if (field.includes("mezzoPubblicoNazionale")) {
                viaggi.mezzoPubblicoNazionale = event.target.value;
                if (event.target.value === "02") {
                    viaggi.infoMezzoPubblicoNazionale = ""
                }
            } else if (field.includes("infoMezzoPubblicoNazionale")) {
                viaggi.infoMezzoPubblicoNazionale = event.target.value;
            }
        }
        this.setState({viaggiESoggiorni: viaggi, clickSoggiornoEstero: click1, clickSoggiornoNazionale: click2});
        this.controlloDati()
    }

    eliminaRowEstero(i){
        let viaggiESoggiorni = this.state.viaggiESoggiorni;
        let boxesSoggiornoEstero = this.state.boxesSoggiornoEstero
        let clickSoggiornoEstero = this.state.clickSoggiornoEstero
        viaggiESoggiorni.estero.splice(i,1)
        boxesSoggiornoEstero.splice(i,1)
        this.setState({boxesSoggiornoEstero: boxesSoggiornoEstero, viaggiESoggiorni: viaggiESoggiorni});
        if(i===1) clickSoggiornoEstero = clickSoggiornoEstero - 1
        else clickSoggiornoEstero = clickSoggiornoEstero - 2
        this.onClickAggiungiSoggiornoEstero(clickSoggiornoEstero)

    }

    onClickAggiungiSoggiornoEstero(clickSoggiornoEstero) {
        const {t} = this.props;
        let click = clickSoggiornoEstero ? clickSoggiornoEstero : this.state.clickSoggiornoEstero === this.state.viaggiESoggiorni.estero.length ? this.state.clickSoggiornoEstero : this.state.clickSoggiornoEstero + 1
        let boxEstero = [];
        for (let i = 0; i < click; i++) {
            boxEstero.push(
                <div>
                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.ViaggiSoggiorni.paeseEstero")}</p>{this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "1" ?
                            <span className={styles.mandatoryColor}>*</span> : <span/>}
                            <div>
                                <Autocomplete id={"paeseEstero".concat(i)}
                                              value={this.state.viaggiESoggiorni.estero[i].paeseEsteroVisitato}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"paeseEstero".concat(i)}
                                              placeholder={t("DatiSpecifici.ViaggiSoggiorni.paeseEstero")}
                                              suggestions={this.state.nazioni}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.ViaggiSoggiorni.motivoViaggio")}</p>{this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "1" ?
                            <span className={styles.mandatoryColor}>*</span> : <span/>}
                            <div>
                                <Select
                                    old={true}
                                    value={this.state.viaggiESoggiorni.estero[i].motivoDelViaggio}
                                    onChange={this.handleChangeMotivo}
                                    id={"motivoViaggio".concat(i)}
                                    functionMap={this.state.motivoViaggi.map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}>

                                </Select>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            {
                                i>0 && !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                    <span id={"esteroElimina"+i}
                                          onClick={()=>
                                              this.eliminaRowEstero(i)

                                          }
                                    ><Icon id={"it-delete"} style={{fill: "red",float: "right", marginTop: "2rem", cursor: "pointer"}} /></span>
                                    : <></>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div>
                                <p className={styles.testo} style={{color: "#1b7ea9"}}>
                                    {t("DatiSpecifici.ViaggiSoggiorni.dataPartenzaItalia")}
                                </p>
                                <Calendar
                                    id={"dataDiPartenzaDallItalia".concat(i)}
                                    value={this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia}
                                    field={"dataDiPartenzaDallItalia".concat(i)}
                                    onChange={this.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                        t("Data Di Partenza Dall'Italia"))}

                                    error={(this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia === "" ||
                                        this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.viaggiESoggiorni.estero[i].dataDiPartenzaDallItalia), "-")}
                                >
                                </Calendar>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo} style={{color: "#1b7ea9"}}>
                                {t("DatiSpecifici.ViaggiSoggiorni.dataRientroItalia")}
                            </p>
                            <Calendar
                                id={"dataRientroOArrivoInItalia".concat(i)}
                                value={this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia}
                                field={"dataRientroOArrivoInItalia".concat(i)}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    t("DatiSpecifici.ViaggiSoggiorni.dataRientroItalia"))}
                                error={(this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia === "" ||
                                    this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.viaggiESoggiorni.estero[i].dataRientroOArrivoInItalia), "-")}
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>  {t("DatiSpecifici.ViaggiSoggiorni.periodoPresenzaItalia")}</p>
                            <div>
                                <Select
                                    old={true}
                                    value={this.state.viaggiESoggiorni.estero[i].periodoDiPresenzaInItalia}
                                    id={"periodoDiPresenzaInItalia".concat(i)}
                                    onChange={this.handleChangePresenza}
                                    functionMap={this.state.tempoPrezenzaItalia.map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}
                                >

                                </Select>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                             style={{marginTop: "2rem"}}>
                            {i < 1 ? <Button
                                    onClick={() => {
                                        this.aggiungiEstero();
                                        this.onClickAggiungiSoggiornoEstero()
                                    }}

                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        border: "none", background: "none", float: "right", fontSize: "16px",
                                        opacity: (this.props.segnalazioneCopia.migrazione || this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "0.5" : ""
                                    }}
                                    text="Aggiungi viaggio/soggiorno "
                                    icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                    disabled={this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                />
                                : <div/>}
                        </div>
                    </div>
                    <div style={{display: this.props.segnalazioneCopia.malattia === "0578" ? "" : "none"}}>
                        <p className={styles.testo} style={{color: "#1b7ea9"}}>
                            {t("DatiSpecifici.ViaggiSoggiorni.note")}
                        </p>
                        <Input
                            type={"textarea"}
                            id={"noteEstero".concat(i)}
                            field={"noteEstero".concat(i)}
                            onChange={this.riceviValore}
                            value={this.state.viaggiESoggiorni.estero[i].noteEstero}
                            placeholder={"Note"}
                        />
                    </div>
                </div>
            )
        }

        this.setState({clickSoggiornoEstero: click, boxesSoggiornoEstero: boxEstero});
        this.controlloDati()

    }

    aggiungiEstero() {
        let strutturaEstero = this.state.viaggiESoggiorni;
        strutturaEstero.estero.push({
            paeseEsteroVisitato: "",
            motivoDelViaggio: "",
            dataDiPartenzaDallItalia: "",
            dataRientroOArrivoInItalia: "",
            periodoDiPresenzaInItalia: "",
            noteEstero: ""
        });
        this.setState({viaggiESoggiorni: strutturaEstero});
        this.controlloDati()
    }

    eliminaRowNazionale(i){
        let viaggiESoggiorni = this.state.viaggiESoggiorni;
        let boxesSoggiornoNazionale = this.state.boxesSoggiornoNazionale
        let clickSoggiornoNazionale = this.state.clickSoggiornoNazionale
        viaggiESoggiorni.nazionale.splice(i,1)
        boxesSoggiornoNazionale.splice(i,1)
        this.setState({boxesSoggiornoNazionale: boxesSoggiornoNazionale, viaggiESoggiorni: viaggiESoggiorni});
        if(i===1) clickSoggiornoNazionale = clickSoggiornoNazionale - 1
        else clickSoggiornoNazionale = clickSoggiornoNazionale - 2
        this.onClickAggiungiSoggiornoNazionale(clickSoggiornoNazionale)

    }

    onClickAggiungiSoggiornoNazionale(clickSoggiornoNazionale) {
        const {t} = this.props;
        let click = clickSoggiornoNazionale ? clickSoggiornoNazionale : this.state.clickSoggiornoNazionale === this.state.viaggiESoggiorni.nazionale.length ? this.state.clickSoggiornoNazionale : this.state.clickSoggiornoNazionale + 1
        let boxNazionale = [];
        for (let i = 0; i < click; i++) {
            boxNazionale.push(
                <div>
                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.ViaggiSoggiorni.provincia")}</p>{this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "1" ?
                            <span className={styles.mandatoryColor} style={{marginLeft: "-1rem"}}>*</span> : <span/>}
                            <Autocomplete id={"provincia".concat(i)}
                                          value={this.state.viaggiESoggiorni.nazionale[i].provincia}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"provincia".concat(i)}
                                          placeholder={t("DatiSpecifici.ViaggiSoggiorni.provincia")}
                                          suggestions={this.state.province}
                                          styles={{marginTop: "10px"}}
                            >
                            </Autocomplete>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div>
                                <p className={styles.testo} style={{color: "#1b7ea9"}}>
                                    {t("DatiSpecifici.ViaggiSoggiorni.dataPartenza")}
                                </p>
                                <Calendar
                                    id={"dataDiPartenza".concat(i)}
                                    value={this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza}
                                    field={"dataDiPartenza".concat(i)}
                                    onChange={this.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                        t("DatiSpecifici.ViaggiSoggiorni.dataPartenza"))}
                                    error={(this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza == "" ||
                                        this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.viaggiESoggiorni.nazionale[i].dataDiPartenza), "-")}
                                >
                                </Calendar>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo} style={{color: "#1b7ea9"}}>
                                {t("DatiSpecifici.ViaggiSoggiorni.dataRientro")}
                            </p>
                            <Calendar
                                id={"dataRientroArrivo".concat(i)}
                                value={this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo}
                                field={"dataRientroArrivo".concat(i)}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    t("Data di reintro/arrivo"))}
                                error={(this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo === "" ||
                                    this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.viaggiESoggiorni.nazionale[i].dataRientroArrivo), "-")}
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                             style={{marginTop: "2rem"}}>
                            {i < 1 ? <Button
                                    onClick={() => {
                                        this.aggiungiNazionale();
                                        this.onClickAggiungiSoggiornoNazionale()
                                    }}

                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        border: "none", background: "none", float: "right", fontSize: "16px",
                                        opacity: (this.props.segnalazioneCopia.migrazione || this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "0.5" : ""
                                    }}
                                    text="Aggiungi viaggio/soggiorno "
                                    icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                    disabled={this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                />
                                : <div className={"col-lg-3"}>
                                    {
                                        i>0 && !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                            <span id={"italiaElimina"+i}
                                                  onClick={()=>
                                                      this.eliminaRowNazionale(i)

                                                  }
                                            ><Icon id={"it-delete"} style={{fill: "red",float: "right", marginTop: "1rem", cursor: "pointer"}} /></span>
                                            : <></>
                                    }
                                </div>}
                        </div>
                    </div>
                    <div style={{display: this.props.segnalazioneCopia.malattia === "0578" ? "" : "none"}}>
                        <p className={styles.testo} style={{color: "#1b7ea9"}}>
                            {t("DatiSpecifici.ViaggiSoggiorni.note")}
                        </p>
                        <Input
                            type={"textarea"}
                            id={"noteNazionale".concat(i)}
                            field={"noteNazionale".concat(i)}
                            onChange={this.riceviValore}
                            value={this.state.viaggiESoggiorni.nazionale[i].noteNazionale}
                            placeholder={"Note"}
                        />
                    </div>
                </div>);
        }
        this.setState({clickSoggiornoNazionale: click, boxesSoggiornoNazionale: boxNazionale});
        this.controlloDati()
    }

    aggiungiNazionale() {
        let strutturaNazionale = this.state.viaggiESoggiorni;
        strutturaNazionale.nazionale
            .push({
                provincia: "",
                dataDiPartenza: "",
                dataRientroArrivo: "",
                noteNazionale: ""
            });
        this.setState({viaggiESoggiorni: strutturaNazionale});
        this.controlloDati()
    }

    render() {
        const {t} = this.props;
        const viaggiSoggiorniFuoriItalia = (
            <div>
                <p className={styles.testo}>{t("DatiSpecifici.ViaggiSoggiorni.viaggiFuoriItalia")}<span
                    className={styles.mandatoryColor}>*</span></p>

                <div className="row">
                    <div className="col-lg-5">
                        <Select
                            id={"viaggiFuoriItalia"}
                            old={true}
                            value={this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3*"? "3" : this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia}
                            onChange={this.handleChangeViaggiFuoriItalia}
                            functionMap={this.state.viaggiFuoriItalia.map((oggetto) => {
                                return (<option value={oggetto.codice}style={{backgroundColor:'white'}}>{oggetto.descrizione}</option>)
                            })}
                            addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.viaggiESoggiorni.viaggiOSoggiorniFuoriItalia === "3*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                            >

                        </Select>
                    </div>
                </div>

                {this.state.boxesSoggiornoEstero}
            </div>

        );

        const viaggiSoggiorniInItalia = (
            <div style={{marginTop: "2rem"}}>
                <p className={styles.testo}>{t("DatiSpecifici.ViaggiSoggiorni.viaggiInItalia")}<span
                    className={styles.mandatoryColor}>*</span></p>
                <div className="row">
                    <div className="col-lg-5">
                        <Select
                            id={"viaggiInItalia"}
                            old={true}
                            value={this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "3*"? "3" : this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia}
                            onChange={this.handleChangeViaggiInItalia}
                            functionMap={this.state.viaggiInItalia.map((oggetto) => {
                                return (<option value={oggetto.codice}style={{backgroundColor:'white'}}>{oggetto.descrizione}</option>)
                            })}
                            addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.viaggiESoggiorni.viaggiOSoggiorniInItalia === "3*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                            >

                        </Select>
                    </div>
                </div>
                {this.state.boxesSoggiornoNazionale}
            </div>
        )

        const viaggiSoggiorniMezzoPubblico = (
            <div className={"row"} style={SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione && this.state.viaggiESoggiorni.mezzoPubblicoNazionale === "01" ? {alignItems: "center", marginTop: "1rem", borderWidth: "5px" ,borderColor: "red" ,borderStyle: "solid"}: {alignItems:"center", marginTop: "1rem"}}>
                <div className="col-lg-4">
                    <p className={styles.labelHeader}>
                        <b>{t("DatiSpecifici.ViaggiSoggiorni.domandaMezzoPubblico")}</b>
                    </p>
                </div>
                <div className="col-lg-2">
                    <div className="row">
                        <RadioButton id={"mezzoPubblicoNazionaleSi"}
                                     name={"mezzoPubblicoNazionaleSi"}
                                     label={t("DatiSpecifici.ViaggiSoggiorni.mezzoPubblicoSi")}
                                     value={"01"}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     checked={this.state.viaggiESoggiorni?.mezzoPubblicoNazionale === "01"}>
                        </RadioButton>
                        <RadioButton id={"mezzoPubblicoNazionaleNo"}
                                     name={"mezzoPubblicoNazionaleNo"}
                                     label={t("DatiSpecifici.ViaggiSoggiorni.mezzoPubblicoNo")}
                                     value={"02"}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     checked={this.state.viaggiESoggiorni.mezzoPubblicoNazionale === "02"}
                        />
                    </div>
                </div>
                <div className="col-lg-6" style={{marginBottom:"1rem"}}>
                    <p className={styles.testo}>
                        {t("DatiSpecifici.ViaggiSoggiorni.infoMezzoPubblico")}
                    </p>
                    <Input
                        type={"textarea"}
                        id={"infoMezzoPubblicoNazionale"}
                        field={"infoMezzoPubblicoNazionale"}
                        onChange={this.riceviValore}
                        value={this.state.viaggiESoggiorni.infoMezzoPubblicoNazionale}
                        placeholder={"Informazioni mezzo di trasporto"}
                        disabled={this.state.viaggiESoggiorni.mezzoPubblicoNazionale === "02" || !this.state.viaggiESoggiorni.mezzoPubblicoNazionale}
                    />
                </div>
            </div>
        )


        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("DatiSpecifici.ViaggiSoggiorni.titolo")}</h6>
                <hr className={styles.hr}/>

                <div className={"container"}>
                    {viaggiSoggiorniFuoriItalia}
                    {viaggiSoggiorniInItalia}
                    {viaggiSoggiorniMezzoPubblico}
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(ViaggiSoggiorni)
